// extracted by mini-css-extract-plugin
export default {"addButton":"UserModal_addButton__5KFaY","buttonText":"UserModal_buttonText__pAcMd","buttonIcon":"UserModal_buttonIcon__0EyAQ"};